import {
  ChangeDetectionStrategy,
  Component,
  ComponentRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewContainerRef
} from '@angular/core';

import { NotificationsToast, NotificationsToastComponent } from '../notifications-toast.domain';

@Component({
  selector: 'td-wb-notification-toast-wrapper',
  templateUrl: './notification-toast-wrapper.component.html',
  styleUrls: ['./notification-toast-wrapper.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NotificationToastWrapperComponent implements OnInit, OnDestroy {

  @Input() toast: NotificationsToast;
  @Input() expiryDuration: number;
  @Input() excessMessageCount: number;
  @Output() readonly onClose: EventEmitter<NotificationsToast> = new EventEmitter<NotificationsToast>();

  @ViewChild('dynamic', {
    read: ViewContainerRef,
    static: true
  }) viewContainerRef: ViewContainerRef;

  private componentRef: ComponentRef<NotificationsToastComponent>;
  private timer: ReturnType<typeof setTimeout>;

  constructor() { }

  /**
   * Init
   * Create toast component
   * Set up close time
   */
  ngOnInit(): void {
    if(this.expiryDuration !== 0) {
      this.timer = setTimeout((): void => {
        this.close();
      }, this.expiryDuration);
    }

    if (this.toast.componentType !== undefined) {
      this.componentRef = this.viewContainerRef.createComponent(this.toast.componentType);
      this.setupComponent(this.componentRef.instance);
      this.viewContainerRef.insert(this.componentRef.hostView);
    }
  }

  /**
   * Destroy
   */
  ngOnDestroy(): void {
    this.componentRef?.destroy();
    clearTimeout(this.timer);
  }

  /**
   * close notification toast
   */
  close(): void {
    this.onClose.emit(this.toast);
  }

  /**
   * Setup toast component
   */
  private setupComponent(component: NotificationsToastComponent): void {
    component.toast = this.toast;
    component.excessMessageCount = this.excessMessageCount;
    component.onClose?.subscribe((): void => {
      this.close();
    });
  }
}
